<template>
    <div class="g g_centralEditions" v-if="display" :style="styles">
        <layout-header @ui="updateUi" />
        <router-view />
        <layout-footer />
    </div>
</template>

<script>
import LayoutHeader from '@/components/layout/LayoutHeader'
import LayoutFooter from '@/components/layout/LayoutFooter'

export default {
    name: 'ViewRoot',
    components: {
        LayoutHeader,
        LayoutFooter
    },
    data() {
        return {
            ui: {
                header: {
                    height: 0
                }
            }
        }
    },
    computed: {
        display() {
            return this.$json !== null
        },
        styles() {
            return { marginTop: `${this.ui.header.height}px` }
        }
    },
    methods: {
        updateUi(header) {
            this.ui.header = header
        }
    }
}
</script>

<style lang="sass">
@import ~assets/sass/common
.g
    background-color: $color_white
    color: $color_black
</style>
